import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'mibDate',
    standalone: false
})
export class MibDatePipe extends
    DatePipe implements PipeTransform {
    override transform(value: any, args?: any): any {
        return super.transform(value, "yyyy-MM-dd");
    }
}